import { HugeiconsIcon } from '@hugeicons/react'
import { Tag01Icon } from '@hugeicons/core-free-icons'
import { useTranslation } from 'react-i18next'
import { usePrimaryPage } from '@/PageManager'
import { switchFeed } from '@/PageManager'
import { unwrappedFavoriteFollowListsWithSetsAtom } from '@/atoms/lists'
import { useAtomValue } from 'jotai'

export default function FollowSets({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const { navigate } = usePrimaryPage()
  const followSets = useAtomValue(unwrappedFavoriteFollowListsWithSetsAtom)

  if (!followSets?.length) return null

  const matched = followSets.filter((set) => set.items.includes(pubkey))
  if (!matched.length) return null

  return (
    <div className="flex items-center gap-1 mt-2 flex-wrap">
      <div className="text-muted-foreground text-xs">{t('Follow sets')}</div>
      {matched.map((set) => (
        <button
          key={set.pointer.pubkey + set.pointer.identifier}
          onClick={() => {
            navigate('home')
            switchFeed({ followSet: set })
          }}
          className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground bg-muted/50 hover:bg-accent/40 rounded px-1.5 py-0.5 transition-colors"
        >
          <HugeiconsIcon icon={Tag01Icon} className="size-3" />
          {set.title}
        </button>
      ))}
    </div>
  )
}
